// extracted by mini-css-extract-plugin
export var homeBtn = "HomeBtn-module--homeBtn--Jl3y0";
export var homeBtnText = "HomeBtn-module--homeBtnText--3kwMg";
export var light = "HomeBtn-module--light--lP0V2";
export var dark = "HomeBtn-module--dark--1Tg2p";
export var hidden = "HomeBtn-module--hidden--1sxBn";